import './projects.css'
import ProjectCard from './ProjectCard'

const Projects = () => {

    const projects = [
    
    
        
        
        {
            link: "https://freshnest-web.onrender.com/",
            background: "bg10",
            category: "A Food Ordering Aggregator (Web & Mobile App)",
            title: "FreshNest",
            subtitle: "Delivering from Cart to Door",
            tech:[
                "flutter.png",
                "react-logo.jpg",
                "NodeJS_Logo.jpg",
                "expressjs_logo.png",
                "mongodb_logo.png",
                // "MySQL_Logo.png",
                // "socket_logo.png",
                "aws_logo.png", 
                "figma_logo.png"
            ]
        },
        {
            link: "https://skillnest-web.onrender.com/",
            background: "bg14",
            category: "An Online Learning Platform",
            title: "SkillNest",
            subtitle: "Empowering students and making quality learning accessible to everyone — completely free of cost.",
            tech:[
                "react-logo.jpg",
                "NodeJS_Logo.jpg",
                "expressjs_logo.png",
                "mongodb_logo.png", 
                "figma_logo.png",
                "flutter.png"
            ]
        },
        // {
        //     link: "https://priyadarshi-PicNest.vercel.app/",
        //     background: "bg11",
        //     category: "A Subsidiary of FreshNest",
        //     title: "PicNest",
        //     subtitle: "A Photo-sharing Web & Mobile App for FreshNest",
        //     tech:[
        //         "flutter.png",
        //         "react-logo.jpg",
        //         "NodeJS_Logo.jpg",
        //         "expressjs_logo.png",
        //         "mongodb_logo.png", 
        //         "figma_logo.png"
        //     ]
        // },
        
        {
            link: "https://samvaad-web.onrender.com",
            background: "bg13",
            category: "A Subsidiary of FreshNest & SkillNest",
            title: "Samvaad",
            subtitle: "A dedicated 24*7 Customer Support Web & Mobile App for both FreshNest & SkillNest",
            tech:[
                "react-logo.jpg",
                "NodeJS_Logo.jpg",
                "expressjs_logo.png",
                "mongodb_logo.png", 
                "socket_logo.png",
                "flutter.png",
                "figma_logo.png"
            ]
        },
        {
            link: "https://swaadsansaar-web.onrender.com",
            background: "bg12",
            category: "A Subsidiary of FreshNest",
            title: "SwaadSansaar",
            subtitle: "A recipe-sharing Web & Mobile App for FreshNest",
            tech: [
                "react-logo.jpg",
                "NodeJS_Logo.jpg",
                "expressjs_logo.png",
                "mongodb_logo.png",
                "figma_logo.png",
                "flutter.png",
            ]
        },
        {
            link: "https://priyadarshi-quiz.vercel.app/",
            background: "bg9",
            category: "Basic ReactJS Project",
            title: "Quiz App",
            subtitle: "Put your ReactJS knowledge to the test.",
            tech:[
                "react-logo.jpg"
            ]
        },
    {
            link: "https://priyadarshi-celebal-2.vercel.app/",
            background: "bg7",
            category: "Basic ReactJS Project",
            title: "To-Do List App",
            subtitle: "Effortlessly add, prioritize, and manage your tasks and activities.",
            tech:[
                "react-logo.jpg"
            ]
        },
        {
            link: "https://priyadarshi-game-1.vercel.app/",
            background: "bg8",
            category: "Basic JavaScript Project",
            title: "Tic-Tac-Toe Game",
            subtitle: "Xs and Os, a battle for tic-tac-toe supremacy!",
            tech:[
                "html.jpg",
                "css.jpg",
                "js.jpeg"
            ]
        },
        {
            link: "https://drive.google.com/drive/u/1/folders/1ansyZk-wx29CrJ7aYkUaKmb6ASXYuHO5",
            background: "bg1",
            category: "Flutter Project",
            title:"Food Delivery App",
            subtitle: "Delivering happiness.....Good food within minutes",
            tech: [
                "flutter.png",
                "firebase.png"
            ]
        },
        {
            link: "https://priyadarshi-sketchbook.vercel.app/",
            background: "bg2",
            category: "Next.js Project",
            title: "Sketchbook App",
            subtitle: "Let this drawing tool become an extension of your creative mind.",
            tech:[
                "Nextjs_Logo.png"
            ]
        },
        
        {
            link: "https://priyadarshi-guess-the-color.vercel.app/",
            background: "bg3",
            category: "JavaScript Game",
            title: "Guess the Color",
            subtitle: "Fun Game to match RGB Code",
            tech:[
                "html.jpg",
                "css.jpg",
                "js.jpeg"
            ]
        },

        {
            link: "https://priyadarshi-netflix-clone.vercel.app",
            background: "bg4",
            category: "Netflix Clone",
            title: "Netflix Clone",
            subtitle: "Spend more time watching than searching",
            tech:[
                "html.jpg",
                "css.jpg",
                "js.jpeg"]
        },

        {
            link: "https://drive.google.com/drive/u/1/folders/1aKE6a0qpT_c1oqK7AGBsYCsllYI8ognv",
            background: "bg5",
            category: "Flutter Project",
            title: "Meals App",
            subtitle: "A simple catalogue of Meals.",
            tech:[
                "flutter.png",
                "firebase.png"
            ]
        },


        {
            link: "https://priyadarshi-result-management-system.vercel.app/",
            background: "bg6",
            category: "Web App",
            title: "Result Management System",
            subtitle: "Enter name and required data to get your marks and percentage.",
            tech:[
                "html.jpg",
                "css.jpg",
                "js.jpeg",
            ]
        },

        {
            link: "https://priyadarshi-to-do-list.vercel.app/",
            background: "bg7",
            category: "Web App",
            title: "ToDo List",
            subtitle: "Effortlessly add, prioritize, and manage your tasks and activities",
            tech: [
                "html.jpg",
                "css.jpg",
                "js.jpeg",

            ]
        }
    ]

    return (
        <div id="project-sec">
            <div>
                <p className="heading sec">Featured <strong>Projects</strong></p>
            </div>

            
            <div className="card-grid">
                <ProjectCard info={projects} />
            </div>
        </div>
    )
}

export default Projects